import React from 'react';
import ResumeGroupedListGroup from './ResumeGroupedListGroup';

class ResumeGroupListSubSection extends React.Component {

    constructor(props) {
        super();
    }

    render() {

        return (
            <section style={this.props.currStyles.Body.GroupedListSubSection}>
                <span style={this.props.currStyles.Body.GroupedListSubSection.title}>{this.props.data.title}</span>
                {this.props.data.groups.map((group) =>
                    <ResumeGroupedListGroup data={group} currStyles={this.props.currStyles}/>
                )}
            </section>
        );
    }
}

export default ResumeGroupListSubSection




// WEBPACK FOOTER //
// src/ResumeAndDocs/ResumeGroupListSubSection.js